import { motion } from "framer-motion";
import { Phone, Mail, Clock, Star } from "lucide-react";
import { PHONE, PHONE_HREF, EMAIL, EMAIL_HREF, REVIEW_URL } from "../lib/site";

const cards = [
  { icon: Phone, label: "Call or Text", value: PHONE, href: PHONE_HREF, testid: "contact-phone" },
  { icon: Mail, label: "Email Me", value: EMAIL, href: EMAIL_HREF, testid: "contact-email" },
];

export const Contact = () => {
  return (
    <section id="contact" className="bg-ink text-ivory py-24 lg:py-32" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="eyebrow text-gold mb-4">Contact Me</p>
          <h2 className="font-serif text-4xl sm:text-5xl tracking-tight">Let&apos;s Make It <span className="gold-text italic">Official</span></h2>
          <span className="block w-16 h-px bg-gold mx-auto mt-6" />
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {cards.map((c, i) => {
            const Icon = c.icon;
            return (
              <motion.a
                key={c.label} href={c.href}
                initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: i * 0.1 }}
                className="group rounded-2xl border border-gold/20 p-8 hover:border-gold/50 hover:bg-white/[0.03] transition-all duration-500 text-center"
                data-testid={c.testid}
              >
                <div className="h-14 w-14 rounded-full border border-gold/30 grid place-items-center mx-auto mb-5 group-hover:scale-110 transition-transform duration-500">
                  <Icon size={22} strokeWidth={1.3} className="text-gold" />
                </div>
                <p className="eyebrow text-taupe text-[10px] mb-2">{c.label}</p>
                <p className="font-serif text-xl text-ivory group-hover:text-gold transition-colors">{c.value}</p>
              </motion.a>
            );
          })}

          <motion.div
            initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.2 }}
            className="rounded-2xl border border-gold/20 p-8 text-center"
            data-testid="contact-hours"
          >
            <div className="h-14 w-14 rounded-full border border-gold/30 grid place-items-center mx-auto mb-5">
              <Clock size={22} strokeWidth={1.3} className="text-gold" />
            </div>
            <p className="eyebrow text-taupe text-[10px] mb-3">Business Hours</p>
            <p className="text-ivory/80 text-sm font-light">Mon – Fri · 8:00 AM – 8:00 PM</p>
            <p className="text-ivory/80 text-sm font-light">Sat – Sun · 9:00 AM – 5:00 PM</p>
          </motion.div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-14">
          <a href="#booking" className="btn-gold rounded-full px-10 py-4 text-xs font-medium tracking-[0.2em] uppercase" data-testid="contact-book-btn">
            Book Appointment
          </a>
          <a href={REVIEW_URL} target="_blank" rel="noopener noreferrer" className="rounded-full px-9 py-4 text-xs font-medium tracking-[0.2em] uppercase border border-gold/40 text-gold hover:bg-gold/10 transition-colors inline-flex items-center gap-2" data-testid="leave-review-btn">
            <Star size={15} className="text-gold" fill="#C6A15B" strokeWidth={0} /> Leave A Google Review
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
